<template>
  <div>
    <cebianlan></cebianlan>
    <!-- 头部 -->
    <banner></banner>
    <!-- 轮播图 -->
    <div style="min-width: 972px;overflow: hidden; background-color: #f5f6f7" class="lunboBanner">
      <CarouselPic/>
      <div v-if="!DisplayKCB" class="onePersonClass">
        <div class="course-categories">
            <span class="course-type" v-for="item in courseCategories" :key="item.id" :class="item.id === curType ? 'active' : ''" @click="changeCourseType(item.id)">{{ item.text }}</span>
        </div>
        <ul class="course-content" v-if="curType!=3">
          <li class="course-item" v-for="item in list" :key="item.id">
            <div v-if="item.pakeage == 1" class="biaoshi_kcb">课程包</div>
            <div class="course-img">
              <img :src="item.cover" alt="" />
              <p class="course-class">{{ item.period }}</p>
            </div>
            <div class="course-desc">
              <h4 class="course-title">{{ item.name }}</h4>
              <div class="course-time" v-if="item.start_time">
                上课时间
                <span>{{ item.start_time.substring(0, 16) }}</span>
              </div>
              <div class="course-time-block" v-else></div>
            </div>
            <div class="study-state">
              <div class="study-time not-begin" v-if="!Number(item.endNum)">未开始学习</div>
              <div class="complete-study study-time" v-else></div>
              <div class="start-study" @click="handleStartStudy(item, item.pakeage)">开始学习</div>
            </div>
          </li>
        </ul>
        <ul class="course-content" v-else>
          <li class="course-item" v-for="item in lists" :key="item.id" @click="tostudy(item)">
            <div class="course-img">
              <img :src="item.img" alt="" />
              <p class="course-class">{{ item.period }}</p>
            </div>
            <div class="course-desc">
            <el-tooltip  v-if="item.name.length>10" class="item" effect="dark" :content="item.name" placement="top-start">
              <h4 class="course-title">{{ item.name }}</h4>
            </el-tooltip>
              <h4 v-else class="course-title">{{ item.name }}</h4>
            </div>
            <div  class="progressbx">
              <p style="font-size: 14px;">已观看 {{ transformation(item.view_time) }}</p>
              <el-progress :percentage="item.percent"></el-progress>
            </div>
          </li>
        </ul>
        <div class="pagination" v-show="pagination.total">
          <el-pagination background  :current-page="pagination.page" @current-change="handleCurrentChange" :page-size="8" layout="total, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
        </div>
      </div>
      <div v-else class="onePersonClass">
        <CoursePackageCourse @fanhuisy="fanhuisy" :cateId="Coursevalue" :Isitthehomepage="2" />
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import banner from './banner'
import Footer from './mofang/footer.vue'
import CarouselPic from './components/carouselPic.vue'
import cebianlan from './cebianlan'
import CoursePackageCourse from './CoursePackageCourse'
export default {
   data(){
    return{
        pagination: {
        page: 1,
        total: 0,
        num: 8,
      },
      curType:0,
      courseCategories: Object.freeze([
        { id: 0, text: '全部课程' },
        { id: 1, text: '免费课程' },
        { id: 2, text: '付费课程' },
        { id: 3, text: '历史观看' },
      ]),
      list: [],
      lists: [],
      DisplayKCB: false,
      Coursevalue: {}
    }
   },
   components: {
    banner,
    Footer,
    cebianlan,
    CarouselPic,
    CoursePackageCourse
  },
  created() {
    if(this.$route.query.subTab === '4') {
      this.curType = 3
      this.historyinit()
    } else {
      this.getCourseList()
    }
  },
  methods: {
    fanhuisy() {
      this.DisplayKCB = false
      this.Coursevalue = {}
    },
    tostudy(val){
      console.log(val);
      this.$router.push({ path: `/yueke3/${val.course_id}/${val.class_id}`,query:{
        view_time:val.view_time,video_id:val.video_id,chapter_id:val.chapter_id,sectionId:val.sectionId,name:val.name,duration:val.duration,file_id:val.file_id
      }})
    },
    async getCourseList() {
      const data = {
        page: this.pagination.page,
        num: this.pagination.num,
        type: this.curType,
      }
      const res = await this.$axios.post('/stu/course/myCourses', data)
      if (res.data.status === 'success') {
        const listObj = res.data.data
        this.list = listObj.list
        this.pagination.total = listObj.count
      }
    },
    transformation(duration) {
      let g = duration;
      let m = parseInt((duration / 60) % 60);
      let s = duration % 60;
      if (s <= 9) {
        s = "0" + s;
      }
      if (m <= 9) {
        m = "0" + m;
      }
      if (g >= 3600) {
        g = g / 3600;
        g = parseInt(g);
        g = "0" + g + ":";
      } else {
        g = "";
      }
      return g + m + ":" + s;
    },
    changeCourseType(idx) {
      console.log(idx,'idx');
      this.curType = idx
      this.pagination.page = 1
      if (idx==3) {
        this.historyinit()
        return
      }
      this.getCourseList()
    },
    async historyinit(){
        const data = {
            page:this.pagination.page,
            page_num:8
        }
        const res = await this.$axios.post('/user/video/history',data)
        this.lists = res.data.data.data
        this.pagination.total = res.data.data.count
        // this.pageSize = (res.data.data.count>10?Math.ceil(res.data.data.count/10):1)
        console.log(res.data.data.count,'this.pageSize');
        // this.lista = [...this.lista, ...res.data.data.list]
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      if (this.curType==3) {
        this.historyinit()
        return
      }
      this.getCourseList()
    },
    // 跳转到课程详情
    handleStartStudy(val, index) {
      // this.$router.push({ path: `/yueke3?setid=${val.course_id}&class_id=${val.class_id}` })
      if (index == 0) {
        this.$router.push({ path: `/yueke3/${val.course_id}/${val.class_id}` })
      } else {
        this.DisplayKCB = true
        this.Coursevalue = val
      }
    },
  },
}
</script>

<style scoped>
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: linear-gradient(135deg, #73aaff 5%, #0053ff 95%) !important;
}
.lunboBanner /deep/ .el-carousel__container {
  height: 100% !important;
}
*{
  margin: 0;
  padding: 0;
}
.biaoshi_kcb {
  position: absolute;
  width: 60px;
  height: 28px;
  margin-top: 10px;
  margin-left: 10px;
  opacity: 0.7;
  background: #000000;
  border-radius: 4px;
  text-align: center;
  line-height: 28px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: Regular;
  color: #ffffff;
  z-index: 100;
}
.title {
  font-size: 20px;
  color: #202020;
  padding-bottom: 17px;
  border-bottom: 1px solid #e8eaec;
}
.course-categories {
  margin: 20px 0;
}
.course-type {
  width: 84px;
  height: 34px;
  display: inline-block;
  line-height: 34px;
  color: #202020;
  font-size: 14px;
  text-align: center;
  border-radius: 17px;
  margin-right: 20px;
  cursor: pointer;
  transition: all 0.5s;
}
.active {
  color: #ffffff;
  background: linear-gradient(136deg,#73aaff 2%, #0053ff);
}
.course-content {
  /* width: 940px; */
  display: flex;
  flex-wrap: wrap;
}
.course-item {
  width: 300px;
  height: 320px;
  margin: 0 10px 20px 10px;
  background: #fff;
  border-radius: 4px;
}
ul li {
  list-style-type: none;
}
.course-img {
  position: relative;
  width: 100%;
  height: 200px;
  margin-bottom: 16px;
  overflow: hidden;
  border-radius: 4px 4px 0px 0px;
}
/* @media screen and (min-width: 1280px) {
  .course-img {
    height: 186px;
  }
}
@media screen and (max-width: 1280px) {
  .course-item {
    height: 260px;
  }
  .course-img {
    height: 125px;
  }
} */

.course-img img {
  width: 100%;
  height: 100%;
}
.course-class {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
  height: 36px;
  line-height: 36px;
  color: #ffffff;
  font-size: 14px;
  padding-left: 20px;
  box-sizing: border-box;
}
.course-desc {
  padding: 0 20px;
  margin-bottom: 5px;
  position: relative;
}
.course-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 18px;
  color: #20242f;
  margin-bottom: 9px;
}
.course-time {
  font-size: 14px;
  color: #808695;
}
.course-time-block {
  height: 18px;
}
.course-time .course-time span {
  margin-right: 10px;
}
.study-state {
  display: flex;
  padding: 0 20px;
  justify-content: space-between;
}
.study-state div {
  width: 91px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  border-radius: 17px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  font-size: 14px;
}
.study-state .study-time {
  text-align: left;
}
.complete-study {
  color: #808695;
}
.not-begin {
  color: #FFC102;
}
.studying {
  color: #10a675;
}
.start-study {
  border: 1px solid #1872ed;
  color: #1872ed;
  cursor: pointer;
}
.pagination {
  display: flex;
  width: 100%;
  justify-content: end;
  margin: 10px 0px;
}
.pagination >>> .el-pager li:not(.disabled).active {
  background: #1872ed;
}
.progressbx{
  padding: 10px;
  margin-top: 20px;
}
.course-title2{
 display: none;
 width: 100%;
 position: absolute;
 top: 32px;
 z-index: 99;
 left: 0;
 background: #fff;
}
.course-desc:hover .course-title2{
 display: block;
}
.onePersonClass{
  margin: 0 auto;
  min-height: 200px;
  overflow: hidden;
  background: #f5f6f7;
  margin-bottom:20px;
}
</style>
